<template>
  <div class="product-cantainer">
    <div class="product-main">
      <div class="product-img">
        <div class="prod-img-top">
          <div class="show-img">
            <transition name="fade">
              <el-image
                  :src="nowImg"
                  class="goodImg"
                  :key="nowIndex"
                  :preview-src-list="imgList"
                  v-show="imgList[nowIndex]==nowImg"
                  style="height: 90%;">
                </el-image>
            </transition>
          </div>
          <div class="img-list" v-if="imgList.length>1">
            <img v-for="(item,index) in imgList" :key="index" :src="item" @click="switchImg(index)"
            @mouseover="switchImg(index)"
            :style="nowIndex == index?'border:1px solid #1077FF':''"/>
          </div>
        </div>
      </div>
      <div class="product-details">
        <div class="prod-title-box">
          <p class="prod-title">{{msg.title}}</p>
        </div>
        <div class="prod-info">
          <div class="prod-info-price">
            售价<span style="margin-right: 15px;">-</span>￥{{msg.price}}
          </div>
          <div class="prod-info-detail" v-for="(val,i) in product.spu">
            <p class="model-title">{{val.name}}</p>
            <div class="prod-info-model">
              <div class="info-model" v-for="(item,index) in val.item">
                <div class="model-item" v-model="lableNum"
                :key="index" :style="lableNum==index?'border:1px solid #007AFF;':''"
                @click="switchGoods(index,item.name)">{{item.name}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="statistics">
          <span>数量选择</span>
          <el-input-number v-model="productNum" :min="1" :max="999" style="margin-left: 50px;width: 130px;"></el-input-number>
        </div>
        <div style="color: #8d9ba8;">
          有货
        </div>
        <div class="prod-total">
          <span class="prod-total-txt" v-for="(val,i) in product.spu">{{val.name}} <span class="total-txt">{{lableName}}</span> ，<span class="total-txt">{{productNum}}</span> 件商品</span>
          &nbsp;<span> 合计  ￥<span class="total-txt">{{msg.price*productNum}}</span> 元</span>
        </div>
        <div style="border: 1px white solid;margin-top: 20px;width:100%;height: 15%;">
          <el-button class="myBtn" @click="openDialog">立即购买</el-button>
        </div>
      </div>
    </div>
    <div class="prod-show">
      <p class="prod-show-title">商品详情</p>
      <p style="font-size: 18px;font-weight: 600;margin-top: 10px;">{{msg.title}}</p>
      <div style="width: 100%;height: 60px;margin-top: 20px;display: flex;" v-for="(val,i) in product.spu">
       <div style="border: 1px solid #F3F6F8;">
          <div class="tableTr">{{val.name}}</div>
          <div class="tableTd">
            <p>
              <span v-for="(item,index) in val.item"><span v-if="index">,</span>{{item.name}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="prod-info-list">
        <ul>
        </ul>
      </div>
    </div>
    <!-- 二维码 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogFlag"
      width="30%"
      center>
      <p style="text-align: center;">
        <img src="/static/qr/qrcode.jpg"/>
        <br>
        <span>扫码进入<span style="color: #007aff;">医小智Mall</span>小程序下单</span>
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default{
  data(){
    return{
      num:1,
      imgList:[],
      nowImg:'',
      nowIndex: 0,
      loading: false,
      isHovering: true,
      productNum: 0,
      msg:{
        price:'0'
      },
      product:{},
      dialogFlag:false,
      detailMsg:'',
      sideShow:false,
      lableNum:0,
      lableName:'',
    }
  },
  computed: {},
    mounted() {
      this.handleScroll(); // 初始化时检查一次
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
  methods:{
    loadDataList(){
      var data = JSON.parse(this.$route.query.data)
      data.images.forEach(val=>{
        this.imgList.push(this.$yxz.oss_img(val))
      })
      this.nowImg = this.imgList[0];
      this.msg = data
      this.detailMsg = data.content.replace(/<[^>]*>/g, '');
      this.$api.get({
        url:'/product/goods/' + data.id
      }).then(res=>{
        // 商品详情赋值
        this.product = JSON.parse(res.msg).data
        this.lableName = this.product.spu[0].item[0].name
      })
    },
    switchImg(index){
      this.nowIndex = index
      this.nowImg = this.imgList[index]
    },
    switchGoods(i,name){
      this.lableNum = i
      this.lableName = name
    },
    openDialog(){
      this.dialogFlag = true
    },
     handleScroll() {
          const windowHeight = window.innerHeight || document.documentElement.clientHeight;
          const bodyScrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
          // const offset = 100; // 距离顶部和底部多少像素时显示或隐藏盒子
          const topOffset = 600
          const botOffset = 100

          // 判断是否到达顶部或底部的条件
          const nearTop = bodyScrollTop >= topOffset;
          const nearBottom = docHeight - (bodyScrollTop + windowHeight) <= botOffset;

          // 根据条件更新sideShow的值
          this.sideShow = nearTop && !nearBottom;
        },
  },
  created(){
    this.isHovering = false
    this.loadDataList();
  },
}
</script>

<style scoped>
.product-cantainer{
  width: 100%;
  height: auto;
  background-color: #FFFFFF;
}
.product-main{
  width: 63%;
  height: 650px;
  margin: 30px auto;
  /* border: 1px solid #ccc; */
  position: relative;
}
.product-img{
  width:60%;
  height:100%;
  float:left;
  /* border: 1px solid yellow; */
}
.prod-img-top{
  width: 100%;
  height: 100%;
  clear:both;
  /* border: 1px solid red; */
}
.prod-img-bottom{
  width: 100%;
  height: 35%;
  margin-top: 20%;
}
.product-details{
  width:35%;
  height:60%;
  float:left;
  margin-left: 2%;
  /* border: 1px solid green; */
}
.prod-title-box{
  width: 100%;
  height: 15%;
  font-size: 20px;
  line-height:40px;
  color: black;
  .prod-title{
    font-size: 25px;
    font-weight: 550;
  }
  }
  .title-type{
    font-size: 12px;
    color: #007aff;
  }
.prod-info{
  width: 100%;
  height: auto;
  .prod-info-price{
    width: 100%;
    height: 25%;
    line-height: 50px;
    text-indent: 10px;
    background-color: #F3F6F8;
    span{
      margin-left: 15px;
    }
  }
  .prod-info-detail{
    width: 100%;
    height: auto;
    margin-top: 5%;
    font-size: 13px;
    /* background-color: yellow; */
    .info-detail{
      width: 100%;
      height: 50%;
      .detail-item{
        width: 33.33%;
        height: 50%;
        float: left;
      }
    }
    .prod-info-model{
      width: 100%;
      height: auto;
      display: flex;
      /* border: 1px solid red; */
      .model-title{
        color: #999;
        line-height: 20px;
        /* background-color: red; */
      }
      .info-model{
        width: auto;
        height: auto;
        margin-right: 10px;
      }
      .model-item{
        color: #AAAAAA;
        padding: 5px 10px;
        margin:12px 1% 0 0;
        border-radius: 2px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        background-color: #F3F6F8;
      }
    }
  }
}
.prod-total{
  margin-top: 15px;
  width: 100%;
  height: 17%;
  background-color: #F3F6F8;
  .prod-total-txt{
    line-height: 60px;
    margin-left: 10px;
  }
}
.total-txt{
  color: #1077FF;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
   background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n+1) {
   background-color: #d3dce6;
}
.img-list{
  width: 65%;
  height: 13%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2% 17%;
  img{
    height: auto;
    flex-shrink: 0;
    max-width: 25%;
    height: 100%;
    object-fit: cover;
  }
}
.show-img{
  width:90%;
  height: 76%;
  display: flex;
  overflow: hidden;
  /* border: 1px solid #ccc; */
  /* background-color: #FAFAFA; */
  .goodImg{
    margin: 0 auto;
    cursor: crosshair;
  }
}
.isShowCode{
  width: 150px;
  height: 150px;
  position: absolute;
  top: 88%;
  left: 10.7%;
  opacity: 0;
  img{
    width: 150px;
    height: 150px;
  }
}
.prod-img-bottom:hover{
  .isShowCode{
    opacity: 1;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3), 0 1px 3px rgba(0, 0, 0, 0.06);
  }
}
/*
 详情显示
 */
.prod-show{
  width: 63%;
  height: auto;
  margin: 0 auto;
}
.prod-show-title{
  text-align: center;
  font-size: 18px;
  position: relative;/*定位横线（当横线的父元素）*/
  display: block;/*设置为块级元素会独占一行形成上下居中的效果*/
}
.prod-show-title::before,
.prod-show-title::after{
  content: '';
  /*CSS伪类用法*/
  position: absolute;
  /*定位背景横线的位置*/
  top: 52%;
  background: rgba(0, 0, 0, 0.1);
  opacity: 0.5;
  /*宽和高做出来的背景横线*/
  width: 46%;
  height: 1px;
}
.prod-show-title::before {
  left: 54%;/*调整背景横线的左右距离*/
}
.prod-show-title::after {
  right: 54%;/*调整背景横线的左右距离*/
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
  /* background-color: red; */
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  /* background-color: black; */
}
.statistics{
  height: 50px;
  margin-top: 20px;
  border: 1px solid rgba(243,243,243,0.3);
  line-height: 50px;
}
.myBtn{
  width: 100%;
  height: 100%;
  color: white;
  font-size: 18px;
  border-radius: 5px;
  background-color: #007aff;
}
.prod-info-list{
  height: auto;
  margin-bottom: 50px;
  /* border: 1px solid black; */
  /* display: flex; */
  .detailImg{
    width: 50%;
    height: 50%;
    /* border: 1px solid red; */
  }
}
.tableTr,.tableTd{
  display: grid;
  place-items: center;
  font-size: 18px;
}
.tableTr{
  float: left;
  width: 200px;
  height: 100%;
  background-color: #F3F6F8;
}
.tableTd{
  float: left;
  min-width: 200px;
  width: auto;
  height: 100%;
}
.sideBox{
  width: 500px;
  height: 500px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: fixed;
  top: 100px;
  right: 320px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// productDetails.vue?18beddb8